import * as React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useTest } from '@hooks/useTest'
import SellIcon from '@mui/icons-material/SellOutlined'

const SaleFlag = ({ label, className, testId = '' }) => {
  const { generateTestId } = useTest()
  const dataTestId = generateTestId('sale', 'flag')

  return (
    <Box
      className={className}
      data-testid={testId || dataTestId}
      sx={{
        textTransform: 'uppercase',
        position: 'absolute',
        zIndex: 1,
        left: 9,
        top: 9,
        bgcolor: label !== 'COUPON' ? 'error.main' : '#00854a',
        px: '6px',
        py: '3px',
        borderRadius: '2px',
        display: 'flex',
      }}
    >
      {label === 'COUPON' && <SellIcon style={{ color: 'white', padding: '2.5px', paddingBottom: '0px' }} />}
      <Typography color="common.white" variant="body1" fontWeight={600} lineHeight="24px" noWrap>
        {label}
      </Typography>
    </Box>
  )
}

SaleFlag.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
}

export default SaleFlag
